import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10a78a30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "TransferPageBackground" }
const _hoisted_2 = { id: "leftMenuContainer" }
const _hoisted_3 = { id: "rowMenuContainer" }
const _hoisted_4 = { id: "collMenuContainer" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { id: "transferInfo" }
const _hoisted_7 = { id: "rightInfoContainer" }
const _hoisted_8 = { id: "header" }
const _hoisted_9 = { id: "headerMainContainer" }
const _hoisted_10 = { id: "headerLine1" }
const _hoisted_11 = { id: "majorName" }
const _hoisted_12 = { id: "headerLine2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "menuContainer" }, " 包含专业 ", -1))
const _hoisted_14 = { id: "mainBody" }

import MobileIncludingMajors from './MobileIncludingMajors.vue';
  import {ElMessage} from 'element-plus';
  import {ref, reactive, nextTick, computed, watch,inject} from 'vue';
  import {getMajor, getSubject, majorsGetLevelList} from "@/network/axios";
  import {useRouter, useRoute} from "vue-router";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MobileTransferPage',
  setup(__props) {

_useCssVars(_ctx => ({
  "0745c113": (_unref(transitionTime)),
  "55b0bc45": (_unref(pointerEvents))
}))

  let refresh: any = inject('refresh');
  let router = useRouter();
  let route = useRoute();

  //获取 inlcudingMajors 的元素
  let including = ref();

  //获取横向菜单栏的item
  let transverseMenu = ref([])
  majorsGetLevelList('/majors/getLevelList').then((res)=>{
    if (res.data.code == 200){
      transverseMenu.value =res.data.data
    }else {
      ElMessage({
        type:'warning',
        message:res.data.message,
      })
    }
  })

  //给横向菜单栏改名字
  let changeTransverseMenu = (name:any)=>{
    if (name=='普通本科'){
      return '普本'
    }else if (name == '职业本科'){
      return '职本'
    }else if (name == '高职专科'){
      return '专科'
    }else {
      return name
    }
  }


  //菜单栏弹出
  let menuDrawer = ref(false);
  //纵向菜单栏的 dom
  let collMenuRef = ref();
  //纵向菜单栏 展开的index
  let collMenuOpenIndex = ref('');
  //路由 传过来的id
  let code = ref(route.params.id);
  let collegeCode = ref(route.params.collegeCode);

  if (code.value.length <= 3 || code.value.length == 5) {
    code.value = '0101';
    router.push('/MobileTransferPage/0101');
    ElMessage({
      message: '查无此信息，页面自动跳转',
      type: 'warning',
      offset: 200,
    })
  } else if (code.value.length >= 6) {
    if (collegeCode.value){
      router.push('/MobileMajorSituation/'+collegeCode.value+'/'+ code.value);
    }else {
      router.push('/MobileMajorSituation/' + code.value);
    }

  }

  let transferPageInfo: any = reactive({
    //返回的  学历,专业类，国标代码
    level: '',
    subject: '',
    subjectCode: '',
    //返回的一级学科
    subjectInfo: [],
    //返回的 具体专业
    majorInfo: [],
  });

  getMajor('/majors/getMajors', {
    params: {
      majorGroup: code.value
    }
  }).then((res) => {
    // console.log(res.data);
    if (res.data.code == '200') {
      transferPageInfo.level = res.data.data.level;
      transferPageInfo.subject = res.data.data.majorGroup;
      transferPageInfo.subjectCode = res.data.data.majorGroupCode;
      transferPageInfo.majorInfo = [];
      transferPageInfo.majorInfo = res.data.data.majors;
      getSubject('/majors/getMajorGroup', {
        params: {
          level: transferPageInfo.level
        }
      }).then((res) => {
        // console.log(res.data);
        transferPageInfo.subjectInfo = [];
        for (const key in res.data.data) {
          transferPageInfo.subjectInfo.push(res.data.data[key]);
        }
        // console.log(transferPageInfo.subjectInfo)
      });
    }
    //如果传4位数，但是没有。就自动传 哲学：0101
    else if (res.data.data == null && code.value.length == 4) {
      getMajor('/majors/getMajors', {
        params: {
          majorGroup: '0101'
        }
      }).then((res) => {
        code.value = '0101';
        router.push('/TransferPage/0101');
        ElMessage({
          message: '查无此信息，页面自动跳转',
          type: 'warning',
          offset: 200,
        });
        transferPageInfo.level = res.data.data.level;
        transferPageInfo.subject = res.data.data.majorGroup;
        transferPageInfo.subjectCode = res.data.data.majorGroupCode;
        transferPageInfo.majorInfo = [];
        transferPageInfo.majorInfo = res.data.data.majors;
        getSubject('/majors/getMajorGroup', {
          params: {
            level: transferPageInfo.level
          }
        }).then((res) => {
          // console.log(res.data);
          transferPageInfo.subjectInfo = [];
          for (const key in res.data.data) {
            transferPageInfo.subjectInfo.push(res.data.data[key]);
          }
          // console.log(transferPageInfo.subjectInfo)
        });
      })
    }
  });

  //点击 职业本科，无法再点击 学科门类
  let pointerEvents = computed(() => {
    if (transferPageInfo.level == '2') {
      return 'none'
    } else{
      return 'auto'
    }
  });

  // 点击横向菜单栏， 让纵向菜单栏的transition时间为0s。600ms后纵向菜单栏的transition时间为0.3s
  let transitionTime = ref('all 0.3s');
  watch(() => {
    return transferPageInfo.level
  }, () => {
    transitionTime.value = 'all 0s';
    setTimeout(() => {
      transitionTime.value = 'all 0.3s'
    }, 600)
  });

  //监听路由参数，刷新页面。解决点击浏览器自带 返回 按钮问题
  watch(() => {
    return route.params.id
  }, (newVal:any, oldVal:any) => {
    if ((String(oldVal).length<5) && route.meta.title=='专业查询'){
      refresh.reload();
    }
  });


  let goDisciplinePage = (category: any, type: any) => {
    router.push('/MobileDisciplinePage/' + category + '/' + type)
    // console.log(id)
  };



  //点击 横向菜单栏 ：本科、专科、职业本科
  let rowMenuSelect = (key: any) => {
    if (transferPageInfo.level != key) {
      transferPageInfo.level = key;
      getSubject('/majors/getMajorGroup', {
        params: {
          level: key
        }
      }).then((res) => {
        // console.log(res.data);
        // console.log(code.value);
        transferPageInfo.subjectInfo = [];
        for (const key in res.data.data) {
          transferPageInfo.subjectInfo.push(res.data.data[key]);
        }
        nextTick(() => {
          collMenuRef.value.close(collMenuOpenIndex.value);
        })
      });
    }
  };

  rowMenuSelect(transferPageInfo.level)

  //纵向菜单栏的 open 回调
  let openCollMenu = (index: any) => {
    collMenuOpenIndex.value = index
  };


  //点击纵向菜单栏里的 item
  let clickMenuItem = (majorGroupCode: any) => {
    //调用 MobileIncludingMajors 组件里的goScrollBar() 方法
    // including.value.goScrollBar();

    router.push('/MobileTransferPage/' + majorGroupCode);
    // getMajor('/majors/getMajors', {
    //   params: {
    //     majorGroup: majorGroupCode,
    //   }
    // }).then((res) => {
    //   // console.log(res.data);
    //   transferPageInfo.level = res.data.data.level;
    //   transferPageInfo.subject = res.data.data.majorGroup;
    //   transferPageInfo.subjectCode = res.data.data.majorGroupCode;
    //   transferPageInfo.majorInfo = [];
    //   transferPageInfo.majorInfo = res.data.data.majors;
    //   menuDrawer.value = false
    // })
  };

  let goFirstPage = () => {
    router.push('/MobileFirstPage')
  }

  let goProfessionSearch = () => {
    router.push('/MobileProfessionSearch')
  };

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_drawer, {
      modelValue: _unref(menuDrawer),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(menuDrawer) ? (menuDrawer).value = $event : menuDrawer = $event)),
      "with-header": false,
      direction: "ltr",
      size: "260"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_menu, {
              "default-active": String(_unref(transferPageInfo).level),
              mode: "horizontal",
              onSelect: _unref(rowMenuSelect),
              ellipsis: false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(transverseMenu), (item) => {
                  return (_openBlock(), _createBlock(_component_el_menu_item, {
                    index: String(item.id)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(changeTransverseMenu)(item.name)), 1)
                    ]),
                    _: 2
                  }, 1032, ["index"]))
                }), 256))
              ]),
              _: 1
            }, 8, ["default-active", "onSelect"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_menu, {
              "unique-opened": true,
              class: "el-menu-vertical-demo",
              ref_key: "collMenuRef",
              ref: collMenuRef,
              onOpen: _unref(openCollMenu),
              "default-active": _unref(code)
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(transferPageInfo).subjectInfo, (item, i) => {
                  return (_openBlock(), _createBlock(_component_el_sub_menu, {
                    index: String(i)
                  }, {
                    title: _withCtx(() => [
                      _createElementVNode("a", {
                        id: "discipline",
                        onClick: _withModifiers(($event: any) => (_unref(goDisciplinePage)(item[0].subjectCategoryId,_unref(transferPageInfo).level)), ["stop"])
                      }, _toDisplayString(item[0].categories), 9, _hoisted_5)
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (item2, j) => {
                        return (_openBlock(), _createBlock(_component_el_menu_item, {
                          onClick: ($event: any) => (_unref(clickMenuItem)(item2.majorCategoryCode)),
                          index: String(item2.majorCategoryCode)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item2.majorCategory), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "index"]))
                      }), 256))
                    ]),
                    _: 2
                  }, 1032, ["index"]))
                }), 256))
              ]),
              _: 1
            }, 8, ["onOpen", "default-active"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(transferPageInfo).subject), 1),
              _createElementVNode("div", null, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  id: "collegeInquireBtn",
                  onClick: _unref(goFirstPage)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("院校查询")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  class: "deepBlueBtn",
                  type: "primary",
                  onClick: _unref(goProfessionSearch)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("职业查询")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", null, "国标代码 " + _toDisplayString(_unref(transferPageInfo).subjectCode) + "(不可用于填报)", 1),
              _createVNode(_component_el_button, {
                id: "displayMenuBtn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(menuDrawer) //@ts-ignore
 ? menuDrawer.value = true : menuDrawer=true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("展开菜单")
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_13
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(MobileIncludingMajors, {
            majorArray: _unref(transferPageInfo).majorInfo,
            ref_key: "including",
            ref: including
          }, null, 8, ["majorArray"])
        ])
      ])
    ])
  ]))
}
}

})